import { EnvironmentConfig } from './env.types';

export const environment: EnvironmentConfig = {
  name: 'staging',
  apiUrl: 'https://api.stg-clearsky.terabase.tech/api/v1',
  authConfig: {
    region: 'us-west-2',
    clientId: '6brqk8mo67qpd4miacc040d62r',
    identityPoolId: '6d354192-aa24-4f68-aa2c-f469d6d0298c',
    responseType: 'code',
    userPool: 'us-west-2_OipCrZ7yU',
    signOutRedirect: 'https://www.stg-clearsky.terabase.services/',
  },
  bucketName: 'terabase-stg-image-proc',
  authDomain: 'terabase-stg.auth.us-west-2.amazoncognito.com',
  cookieDomain: 'terabase.services',
  internalCompanyIds: ['61f96410bde8a5d47cb714e4', '617adad8d7eda483e1ea3661'],
};
